import { Component } from 'preact';

import { QUESTIONS } from '../../constants';

import PageScroller from '../page-scroller';

import Welcome from '../welcome';
import Intro from '../intro';

import { trackEvent, trackScreen, trackButtonClick } from '../../utils/tracking';

export default class Start extends Component {

	componentDidMount() {
		trackScreen('landing_page_visit');
		// trackEvent('landing_page_visit');
		// begin preloading background images
		let images = QUESTIONS.filter( question => 'image' in question ).map( question => question.image );
		images = ['splash-min.jpg', 'intro-min.jpg', 'splash-min.jpg', ...images];
		images.forEach( question => {
			let image = new Image();
			image.src = `assets/${question.image}`;
		});
	}

	takeSurvey = () => {
		trackButtonClick('Take Survey');
		trackScreen('demo_gender_visit');
		// trackEvent('take_survey_button_click');
		// trackEvent('demo_gender_visit');
		this.pageScroller.goToPage(1);
	}

	goToPage = pageNumber => this.pageScroller.goToPage(pageNumber)

	render() {
		return (
			<PageScroller
				ref={c => this.pageScroller = c}
				overflow={true}
			>
				<Welcome next={this.takeSurvey} />
				<Intro finish={this.props.startComplete} />
			</PageScroller>
		);
	}
}



// WEBPACK FOOTER //
// ./components/start/index.js